import React, { Component } from 'react'
import $ from 'jquery';
import { ApiClient } from '../libs/apiClient';
import "../views/pointOfSale/PointOfSaleView.css";

let apiClient = ApiClient.getInstance();
class BatchReportModal extends Component {
    Close = async () =>{
        const {CleanData} = this.props;
        $('#batchReportModal').modal('hide');
        await CleanData();
    }
    
    StatusType = (value) => {
        let status = ''
        switch (Number(value)) {
            case 0:
                status = 'Liberado';
                break;
            case 1:
                status = 'Sin acceso';
                break;
            case 2:
                status = 'Bloqueado';
                break;
        
            default:
                break;
        }
        return status
    }

    SelectBatch = async (index) => {
        const {BatchReports, RefreshBatchs, enableSpinner, showAlert} = this.props;
        for (let indez = 0; indez < BatchReports.length; indez++) {
            const batch = BatchReports[indez];
            if(indez === index){
                batch.BatchSelected = true;
                let data = {
                    DocEntry: batch.ApplyEntry,
                    ObjType: batch.ApplyType,
                    ItemCode: batch.ItemCode,
                    SysNumber: batch.SysNumber,
                    WhsCode: batch.WhsCode,
                }
                enableSpinner(true);
                let batchsResponse = await apiClient.getBatchReportLine(data);
                enableSpinner(false);
                if (batchsResponse.status === 0) {
                    showAlert({ type: "error", message: `${batchsResponse.message ?? ''}` });
                    batch.BatchLines = [];
                    return await RefreshBatchs(BatchReports);
                }

                if (batchsResponse.data.length === 0) {
                    showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                    batch.BatchLines = [];
                    return await RefreshBatchs(BatchReports);
                }
                batch.BatchLines = batchsResponse.data || [];
            }else{
                batch.BatchSelected = false;
            }
            
        }
        await RefreshBatchs(BatchReports);
    }

    render() {
        const {BatchReports} = this.props;
        return (
            
            <div className="modal fade" id="batchReportModal" data-keyboard="false" tabIndex="-1" aria-labelledby="batchReportModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343A40" }}>
                            <h5 style={{color: "white"}}>Informe de operaciones de números de lote</h5>
                            <button type="button" className="close" onClick={this.Close} aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-12 p-4'>
                                    <h6><strong>Lotes: </strong></h6>
                                    <div style={{ border: "1px solid #00000020", height: "18vh", overflowY: "scroll" }}>
                                        <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Número de artículo</th>
                                                    <th scope="col">Descripción del artículo</th>
                                                    <th scope="col">Lote</th>
                                                    <th scope="col">Almacén</th>
                                                    <th scope="col">Cantidad</th>
                                                    <th scope="col">Atributo de lote 1</th>
                                                    <th scope="col">Atributo de lote 2</th>
                                                    <th scope="col">Estado</th>
                                                    <th scope="col">F. Vencimiento</th>
                                                    <th scope="col">F. Fabricación</th>
                                                    <th scope="col">F. admisión</th>
                                                    <th scope="col">Localidad</th>
                                                    <th scope="col">Número de sistema</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {BatchReports.map((batch, index)=>{
                                                    return(
                                                        <tr id={`batchReport${index}`} style={{background:`${batch.BatchSelected ? '#FFF8D2':'white'}`}} onClick={()=>this.SelectBatch(index)}>
                                                        <td>{index+1}</td>
                                                        <td>{batch.ItemCode || ''}</td>
                                                        <td>{batch.ItemName || ''}</td>
                                                        <td>{batch.DistNumber || ''}</td>
                                                        <td>{batch.WhsCode || ''}</td>
                                                        <td>{Number.parseFloat(batch.Quantity).toFixed(4) || ''}</td>
                                                        <td>{batch.MnfSerial ||''}</td>
                                                        <td>{batch.LotNumber}</td>
                                                        <td>{this.StatusType(batch.Status)}</td>
                                                        <td>{batch.ExpDate}</td>
                                                        <td>{batch.MnfDate}</td>
                                                        <td>{batch.InDate}</td>
                                                        <td>{batch.Location || ''}</td>
                                                        <td>{batch.SysNumber || ''}</td>
                                                        </tr>
                                                    )
                                                })

                                                }
                                               
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-4 pl-4'>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id=""><strong>Operaciones para lote:</strong></span>
                                        </div>
                                        <input type="text" className="form-control text-center" value={"B001"} disabled/>
                                    </div>
                                </div> 
                            </div>
                           
                            <div className='row'>
                                <div className='col-12 p-4'>

                                    <div style={{ border: "1px solid #00000020", height: "30vh", overflowY: "scroll" }}>

                                        <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Operación</th>
                                                    <th scope="col">Documento</th>
                                                    <th scope="col">Fila documento</th>
                                                    <th scope="col">Fecha</th>
                                                    <th scope="col">Almacén</th>
                                                    <th className='text-center' scope="col">Cuenta de mayor / Nombre SN </th>
                                                    <th scope="col">Cantidad</th>
                                                    <th scope="col">Sentido</th>

                                                </tr>
                                            </thead>
                                            {this.RenderBatchLines()}
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='row'>
                                <div className='col-5 pl-4'>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/>
                                        <label class="form-check-label" for="defaultCheck1">
                                            Visualizar operaciones(todas) para lotes seleccionados.
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/>
                                        <label class="form-check-label" for="defaultCheck1">
                                            Visualizar lotes con cantidad 0.
                                        </label>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <label class="input-group-text" for="inputGroupSelect01">Desde almacén</label>
                                        </div>
                                        <select class="custom-select" id="inputGroupSelect01">
                                            <option selected>Choose...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-3 pr-4'>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <label class="input-group-text" for="inputGroupSelect01">Hasta</label>
                                        </div>
                                        <select class="custom-select" id="inputGroupSelect01">
                                            <option selected>Choose...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>
                            </div>                             */}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect"  onClick={this.Close}>
                                Aceptar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    RenderBatchLines = () => {
        const {BatchReports} = this.props;

        let batchs = BatchReports || [];
        let batchSelected = batchs.find((batch) => batch.BatchSelected === true);
        let BatchLines = []
        if(!batchSelected){
            BatchLines = BatchReports[0].BatchLines || [];
        }else{
            BatchLines = batchSelected.BatchLines || [];
        }
        return(
            <tbody>
                {BatchLines.map((batchLine, index)=>{
                    return(
                        <tr id={`batchLine${index}`}>
                            <td>{index+1}</td>
                            <td>{batchLine.TransId || ''}</td>
                            <td>EN{batchLine.DocNum | ''}</td>
                            <td>{batchLine.DocLine+1}</td>
                            <td>{batchLine.Date || ''}</td>
                            <td>{batchLine.LocCode || ''}</td>
                            <td>{batchLine.CardName}</td>
                            <td>{Number.parseFloat(batchLine.Quantity).toFixed(4) || ''}</td>
                            <td>{`Salida`}</td>
                        </tr>
                    )
                })

                }
                
            </tbody>
        )
    }
}export default BatchReportModal
